import { createFileRoute } from '@tanstack/react-router'
import { SchoolGroupsClient } from '../components/SchoolGroupsClient'

export const Route = createFileRoute('/school/$schoolId/groups')({
  head: () => ({
    meta: [{ title: 'School Groups | Unbreakable' }],
  }),
  component: SchoolGroupsPage,
})

function SchoolGroupsPage() {
  return <SchoolGroupsClient />
}
